export const EventAttendanceContent = {
  tabs: {
    going: 'Going',
    notGoing: 'Not Going',
    attendance: 'Attendance',
  },
  emptyStates: {
    going: 'No one has RSVP’d “Going” yet.',
    notGoing: 'No one has declined this event yet.',
    attendance:
      'Attendance tracking will appear here once an attendee is added.',
  },
  list: {
    emailFallback: 'No email provided',
  },
  buttons: {
    addAttendee: 'Add attendees',
    eventActionsTrigger: 'Event actions',
    editEvent: 'Edit',
    deleteEvent: 'Delete',
    exportEvent: 'Export',
  },
  drawer: {
    actionsTitle: 'Event Actions',
  },
} as const;

